import styled from "styled-components";

export const LiteTradePortfolioStyled = styled.div`
`;
export const LiteTradePortfolioTitleStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 12px;

    h6 {
        color: var(--color-secondary);
    }
`;
export const LiteTradePortfolioSumPlStyled = styled.div`
    font-weight: 600;
    font-size: 16px;
`;
export const LiteTradePortfolioListStyled = styled.div`
    background: rgba(129, 146, 228, 0.1);
    border-radius: 16px;
    margin-bottom: 24px;

`;

export const LiteTradePortfolioListItemWrapperStyled = styled.div`
    padding: 0 16px;

    &:hover {
        background: rgba(129, 146, 228, 0.1);
    }

    > * {
        border-bottom: 1px solid var(--color-base-secondary);
    }

    &:last-child {
        > * {
            border-bottom: none;
        }
    }
`;

export const LiteTradePortfolioItemProgressStyled = styled.div`
    width: 100%;
    height: 4px;
    background: rgba(129, 146, 228, 0.1);
    border-radius: 2px;
    position: relative;

    &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: ${({ progress }) => (`${progress || 1}%`)};
        height: 4px;
        content: '';
        display: block;
        background: #FFDD3C;
        border-radius: 2px;
    }
`;

export const LiteTradePortfolioListItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    max-width: 100%;
    overflow: hidden;

    > * {
        padding: 16px 0;
    }

    &:hover {
        background-color: var();
    }

    .col-left {
        font-size: 28px;
    }

    .col-center {
        flex: 1;
        overflow: hidden;

        * {
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .col-right {
        text-align: right;
        flex-shrink: 0;
    }

    .protection {
        display: inline-flex;
        gap: 2px;

        > span {
            background: rgba(129, 146, 228, 0.2);
            border-radius: 4px;
            padding: 0 4px;
        }
    }

    * {
        white-space: nowrap;
    }

    &.inactive {
        .col-left {
            opacity: 0.5;
        }

        .col-center {
            color: var(--color-white-60);
        }

        .col-right {
            opacity: 0.6;
        }

        .asset-row-info {
            opacity: 0.6;
        }

        .progress {
            &:after {
                background: rgba(129, 146, 228, 0.2);
            }
        }
    }
`;

export const LiteTradePortfolioListItemLoaderStyled = styled.div`
    width: 24px;
`;
